import { CalendarResource } from './calendar';
import { StoreArticlesResource, StoreDepartmentsResource } from './catalog';
import { CandidatesResource } from './candidates';
import { DocumentsResource } from './documents';
import { HabitsResource } from './habits';
import { HealthResource } from './health';
import { KnowhowNotesResource } from './knowhow-notes';
import { HttpClient, type HttpClientConfig } from './http';
import { ListsResource } from './lists';
import { MailResource } from './mail';
import { PlannerResource } from './planner';
import { ProjectsResource } from './projects';
import { RoadmapResource } from './roadmap';
import { StoresResource } from './stores';
import { TrackingsResource } from './trackings';

export interface ApiClient {
  health: HealthResource;
  lists: ListsResource;
  stores: StoresResource;
  storeDepartments: StoreDepartmentsResource;
  storeArticles: StoreArticlesResource;
  mail: MailResource;
  trackings: TrackingsResource;
  documents: DocumentsResource;
  planner: PlannerResource;
  candidates: CandidatesResource;
  calendar: CalendarResource;
  habits: HabitsResource;
  projects: ProjectsResource;
  knowhowNotes: KnowhowNotesResource;
  roadmap: RoadmapResource;
}

export function createApiClient(config: HttpClientConfig): ApiClient {
  const http = new HttpClient(config);
  return {
    health: new HealthResource(http),
    lists: new ListsResource(http),
    stores: new StoresResource(http),
    storeDepartments: new StoreDepartmentsResource(http),
    storeArticles: new StoreArticlesResource(http),
    mail: new MailResource(http),
    trackings: new TrackingsResource(http),
    documents: new DocumentsResource(http),
    planner: new PlannerResource(http),
    candidates: new CandidatesResource(http),
    calendar: new CalendarResource(http),
    habits: new HabitsResource(http),
    projects: new ProjectsResource(http),
    knowhowNotes: new KnowhowNotesResource(http),
    roadmap: new RoadmapResource(http),
  };
}
